<template>
  <v-container class="about">
    <template v-if="group.id && $route.params.project">
      <v-btn
        class="activator"
        v-on:click="drawer = true"
        color="white"
        v-if="isNeedQuickSelectAsNavigator"
      >
        {{ $t("analysis.quick-select") }}
        <v-icon color="primary" class="ml-2">mdi-calendar-clock</v-icon>
      </v-btn>
      <v-card class="mb-5">
        <v-container>
          <v-row class="align-start">
            <v-col cols="12" lg="4">
              <h2>{{ group.name }}</h2>
              <p>{{ group.description }}</p>
              <v-autocomplete
                v-model="interval"
                :items="intervals"
                :label="$t('analysis.intervals')"
                prepend-icon="mdi-calendar-clock"
                @change="updateCharts()"
                :item-text="item => $t(item.text)"
              ></v-autocomplete>
              <DateInput
                :date="date_from"
                @update="
                  val => {
                    updateDate('date_from', val);
                  }
                "
                :label="$t('analysis.date-from')"
              >
              </DateInput>
              <DateInput
                :date="date_to"
                @update="
                  val => {
                    updateDate('date_to', val);
                  }
                "
                :label="$t('analysis.date-to')"
              >
              </DateInput>
              <v-switch
                v-model="rawRecord"
                :label="$t('analysis.raw-record')"
                color="primary"
                @change="updateCharts"
              ></v-switch>
            </v-col>
            <component
              :is="
                isNeedQuickSelectAsNavigator ? 'v-navigation-drawer' : 'v-col'
              "
              right
              fixed
              :style="
                isNeedQuickSelectAsNavigator && {
                  paddingTop: $vuetify.application.top + 'px',
                  zIndex: 3
                }
              "
              v-model="drawer"
              cols="12"
              lg="8"
            >
              <v-col class="py-0">
                <v-row>
                  <v-col cols="12" class="py-0"
                    ><h2 class="px-3">
                      {{ $t("analysis.quick-select") }}
                    </h2></v-col
                  >
                  <v-col
                    cols="12"
                    xl="3"
                    lg="6"
                    v-for="select in quickSelect"
                    v-bind:key="select.title"
                    class="quick-select-col"
                  >
                    <p class="px-3 mb-0">
                      <b>{{ $t(select.title) }}</b>
                    </p>
                    <v-btn
                      text
                      :color="
                        isCurrentCharts(item.item) ? 'primary' : undefined
                      "
                      v-for="item in select.items"
                      v-on:click="setCharts(item.item)"
                      v-bind:key="item.title"
                      small
                      class="mt-2 px-3 select-button"
                      >{{ $t(item.title) }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </component>
          </v-row>
        </v-container>
      </v-card>
      <MeterAnalysis
        v-for="meter in group._meters"
        :meter_id="meter.id"
        :project_id="$route.params.project"
        :key="meter.id"
        :options="options"
        class="mb-5"
      ></MeterAnalysis>
    </template>
    <template v-else>
      <h3 class="py-2">{{ $t("analysis.group-not-selected") }}</h3>
    </template>
  </v-container>
</template>
<script>
import MeterAnalysis from "../components/analysis/MeterAnalysis";
import DateInput from "../components/common/inputs/DateInput";
import { VNavigationDrawer } from "vuetify/lib";
import moment from "moment";
export default {
  name: "Analysis",
  components: {
    MeterAnalysis,
    DateInput,
    VNavigationDrawer
  },
  data() {
    let format = "YYYY-MM-DD";
    return {
      intervals: [],
      interval: "day",
      date_from: moment()
        .startOf("week")
        .subtract(4, "week")
        .format(format),
      date_to: moment()
        .endOf("week")
        .subtract(1, "week")
        .format(format),
      rawRecord: true,
      options: {},
      drawer: false
    };
  },

  computed: {
    quickSelect() {
      return this.$store.getters["dashboardStore/getRelativeIntervals"];
    },
    isNeedQuickSelectAsNavigator() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    isHaveGroup() {
      return this.$route.query && this.$route.query.group_id;
    },
    group() {
      return this.$store.getters["projectMeteringStore/groupStore/getItem"];
    }
  },
  watch: {
    "$route.query.group_id": function() {
      this.getItem();
    }
  },
  methods: {
    updateDate(date, val) {
      this[date] = val;
      if (this.options[date] !== this[date]) {
        this.time_mode = "past";
        this.updateCharts();
      }
    },
    getItem() {
      if (this.isHaveGroup) {
        this.$store.dispatch("projectMeteringStore/groupStore/get", {
          id: this.$route.query.group_id,
          project_id: this.$route.params.project
        });
      } else {
        this.$store.commit("projectMeteringStore/groupStore/set", { item: {} });
      }
    },
    updateCharts() {
      this.validateIntervals();
      this.options = {
        interval: this.interval,
        date_from: this.date_from,
        date_to: this.date_to,
        rawRecord: this.rawRecord,
        time_mode: this.time_mode
      };
    },
    setCharts(charts) {
      this.drawer = false;
      this.interval = charts.interval;
      this.date_from = charts.date_from;
      this.date_to = charts.date_to;
      this.time_mode = charts.time_mode;
      this.updateCharts();
    },
    isCurrentCharts(charts) {
      return (
        this.interval === charts.interval &&
        this.date_from === charts.date_from &&
        this.date_to === charts.date_to &&
        this.rawRecord === charts.rawRecord
      );
    },
    validateIntervals() {
      let disabled = true;
      if (!this.time_mode) {
        this.time_mode = "past";
      }
      if (this.date_from) {
        disabled =
          Math.abs(moment(this.date_from).diff(moment(this.date_to), "days")) >
          30;
      }
      if (disabled && (this.interval === "all" || this.interval === "hour")) {
        this.interval = "day";
      }
      this.intervals = [
        { value: "all", text: "analysis.all", disabled },
        { value: "hour", text: "analysis.hour", disabled },
        { value: "day", text: "analysis.day" },
        { value: "week", text: "analysis.week" },
        { value: "month", text: "analysis.month" },
        { value: "year", text: "analysis.year" }
      ];
    }
  },
  mounted() {
    this.getItem();
    this.updateCharts();
  }
};
</script>
<style lang="scss">
.quick-select {
  cursor: pointer;
}
.activator {
  z-index: 2;
  position: fixed;
  top: 48px;
  right: 0;
  background: #fff;
}
.quick-select-col {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
</style>
